function iframeHeightCalc() {
	const iframes = document.querySelectorAll('.iframe--auto-height')

	if (iframes.length > 0) {
		// Function to adjust iframe height with debounce mechanism
		const adjustIframeHeight = (function () {
			const timers = new WeakMap()

			return function (iframe) {
				if (timers.has(iframe)) {
					clearTimeout(timers.get(iframe))
				}

				timers.set(
					iframe,
					setTimeout(() => {
						try {
							const height = iframe.contentWindow.document.body.scrollHeight
							iframe.style.height = height + 'px'
						} catch (e) {}
					}, 100)
				)
			}
		})()

		iframes.forEach((iframe) => {
			iframe.addEventListener('load', function () {
				adjustIframeHeight(iframe)
			})

			try {
				if (iframe.contentDocument) {
					if (window.ResizeObserver) {
						const resizeObserver = new ResizeObserver(() => adjustIframeHeight(iframe))
						resizeObserver.observe(iframe.contentDocument.body)
					} else {
						iframe.contentWindow.addEventListener('resize', () => adjustIframeHeight(iframe))
					}

					const observer = new MutationObserver(() => adjustIframeHeight(iframe))
					observer.observe(iframe.contentDocument.body, {
						childList: true,
						subtree: true,
						attributes: false,
					})
				}
			} catch (e) {
				const interval = setInterval(() => adjustIframeHeight(iframe), 5000)

				const cleanupObserver = new MutationObserver((mutations) => {
					mutations.forEach((mutation) => {
						if ([...mutation.removedNodes].some((node) => node === iframe || node.contains(iframe))) {
							clearInterval(interval)
							cleanupObserver.disconnect()
						}
					})
				})
				cleanupObserver.observe(document.body, { childList: true, subtree: true })
			}
		})
	}
}

const forms = document.querySelectorAll('.yn-form')
forms.forEach((form) => {
	form.addEventListener('onAsyncChange', () => {
		document.querySelectorAll('.iframe--auto-height').forEach((iframe) => {
			iframe.addEventListener('load', iframeHeightCalc)
		})
	})
})

window.rerenderIframes = iframeHeightCalc

export { iframeHeightCalc }
